import { useMemo } from 'react'
import { calculateDealTotals, toNumber } from '../../shared/calculations'

const csaTypes = ['CSA', 'RCSA']
const useTotals = (productRows, initialImplementationFee, type) => {
  const totals = useMemo(() => {
    const deal = {
      implementationFee: initialImplementationFee,
      type,
    }

    const result = calculateDealTotals(deal, Array.isArray(productRows) ? productRows : [])

    // Deal-type-specific display logic:
    // - IO deals: total = contractTotal, monthlyTotal = total / overall months
    // - CSA/RCSA deals: total = monthlyTotal (they bill monthly)
    // - Others: total = contractTotal
    let displayTotal = result.total
    let displayMonthlyTotal = result.monthlyTotal

    if (type === 'IO') {
      // For IO deals, monthlyTotal is the average across all months
      const overallMonths = result.total > 0 && result.monthlyTotal > 0
        ? Math.round(result.total / result.monthlyTotal)
        : 1
      displayMonthlyTotal = overallMonths ? result.total / overallMonths : 0
    } else if (csaTypes.includes(type)) {
      displayTotal = result.monthlyTotal
    }

    return {
      grossProfit: result.grossProfit,
      implementationFee: toNumber(initialImplementationFee),
      setupTotal: result.setupFee,
      monthlyTotal: displayMonthlyTotal,
      total: displayTotal,
      totalGrossProfit: result.totalGrossProfit,
    }
  }, [productRows, initialImplementationFee, type])
  return totals
}

export default useTotals
